(function () {
    'use strict';
    var controllerId = 'stakQuestionTestAdd';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', 'sectionMenu', '$uibModalInstance', 'questions', 'questionId', 'testId', 'testSourceId', stakQuestionTestAdd]);

    function stakQuestionTestAdd($scope, datacontext, sectionMenu, $uibModalInstance, questions, questionId, testId, testSourceId) {
        $scope.questionTest = {};
        $scope.tests = [];        
        $scope.questions = questions;        
        getListTests(testId);

        if (testSourceId) {
        	$scope.testSourceId = testSourceId;
        	$scope.questionTest.testSourceId = testSourceId;
        }

        if (testId) {
        	$scope.questionTest.testId = testId;
        }

        if (questionId) {
            $scope.questionId = questionId;
            $scope.questionTest.questionId = questionId;
        }

        $scope.ok = function (isValid) {
        	if (isValid) {
        		var questionsList = [];
        		$("input:checkbox[name=questionId]:checked").each(function () {
        				questionsList.push($(this).val());
        			});
        		var result = addItem($scope.questionTest.testId, questionsList)
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.test_changed = function () {
        	getListQuestions($scope.questionTest.testSourceId);
        };

        function addItem(testId, questionsList) {
            return datacontext.stak_questionTest_importList(testId, questionsList).then(function (data) {
                if (!data) return null;

                return data;
            });
        }

        function getListTests(testId) {        	
        	return datacontext.stak_test_getAllList().then(function (data) {
        		return $scope.tests = data;
        	});
        }

        function getListQuestions(testId) {           
        	return datacontext.stak_questionTest_getAllList(testId).then(function (data) {
        		return $scope.questions = data;
        	});
        }
    }
})();